"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;

var _styles = require("@material-ui/core/styles");

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: "#fff",
      textAlign: "center"
    },
    messageBox: {
      backgroundColor: "white",
      color: "black",
      top: 0,
      position: "absolute",
      borderRadius: "3px",
      width: "100%",
      padding: "1vh 4vh",
      fontSize: "12pt"
    },
    messageBoxText: {
      paddingLeft: "5%"
    },
    btnAgree: {
      backgroundColor: "lightgray",
      fontSize: "12pt"
    }
  };
});
exports.useStyles = useStyles;